import * as React from "react";

function IconPictureInPictureTop({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-picture-in-picture-top" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/picture-in-picture-top"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4" /><rect transform="matrix(1 0 0 -1 0 15)" x={14} y={5} width={7} height={5} rx={1} /></svg>;
}

export default IconPictureInPictureTop;